import script from "./ToggleButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToggleButtons.vue?vue&type=script&lang=ts&setup=true"

import "./ToggleButtons.vue?vue&type=style&index=0&id=3a19fd5d&lang=postcss"

const __exports__ = script;

export default __exports__